import _get from 'lodash/get'

export default {
  name: 'trans',
  methods: {
    trans: function (string, defaultString) {
      return this.$t(string, defaultString)
    },

    __: function (string, defaultString) {
      return this.trans(string, defaultString)
    },

    trans_choice: function (string, count = 1, defaultString = null) {
      return this.$tc(string, count, defaultString)
    },
  }
}
